<template>

    <div>
        <div class="top"></div>
        <eazyswiper :type="1" :location="1"></eazyswiper>
        <div id="wrapS">
    
            <div id="top_first">
                <div id="center">
                    <!--综合资讯-->
                    <div id="one">
                        <div id="oneHead">
                            <span class="headLeft">综合资讯</span>
                            <a href="javascript:void(0);" class="as" @click="jump(1)">更多&gt;&gt;</a
                                    >
                                </div>
        
                                <!--公用线-->
                                <div class="publicLine">
                                    <div class="publicChild"></div>
                                </div>
                                <!-- 综合资讯 -->
                                <div id="oneContent_left" style="float:left;">
                                    <img :src="refer" style="width:95%;height:230px;margin-top:10px;">
                                </div>
                                <div id="oneContent" style="float:left;">
                                    <div
                                        class="oneDivs"
                                        v-for="(val, index) in arrOne"
                                        :key="index"
                                    >
                                        <p class="onePs">
                                            <div class="ball"></div>
                                            <span
                                                class="spanTitle"
                                                @click="goDetails(val.id)"
                                                >{{ val.title }}</span
                                            ><span class="spans">{{
                                                val.creaTime.time | dateFormat
                                            }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!--公告通知-->
                            <div id="two">
                                <div id="twoHead">
                                    <span class="headLeft">公告通知</span>
                                    <a
                                        href="javascript:void(0);"
                                        class="as"
                                        @click="jump(2)"
                                        >更多&gt;&gt;</a
                                    >
                                </div>
                                <!--公用线-->
                                <div class="publicLine">
                                    <div class="publicChild"></div>
                                </div>
                                <div id="twoContent">
                                    <!--公告通知-->
                                    <div
                                        class="twoDivs"
                                        v-for="(val, index) in arrTen"
                                        :key="index"
                                    >
                                        <div class="ball"></div>
                                        <span class="spanTitle" @click="showMessage(val)">{{
                                            val.title
                                        }}</span
                                        ><span class="spans">{{
                                            val.createTime.time &&
                                                val.createTime.time | dateFormat
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--线下活动-->
                    <div id="three">
                        <div id="threeLeft">
                            <div id="threeLeftHead">
                                <span class="headLeft">线下活动</span>
                                <a
                                    href="javascript:void(0);"
                                    class="as"
                                    @click="jump(3)"
                                    >更多&gt;&gt;</a
                                >
                            </div>
                            <!--公用线-->
                            <div class="publicLine white">
                                <div class="publicChild"></div>
                            </div>
                            <div id="threeCenter">
                                状态：
                                <!-- <span
                                    :class="[{ changeColor: isColor[0] }, span1]"
                                    @click="change(0), changeXxhd(4)"
                                    >全部</span
                                > -->
                                <span
                                    :class="[{ changeColor: isColor[3] }, span1]"
                                    @click="change(4), changeXxhd(0)"
                                    >全部</span
                                >
                                <span
                                    :class="[{ changeColor: isColor[0] }, span1]"
                                    @click="change(0), changeXxhd(1)"
                                    >进行中</span
                                >
                                <span
                                    :class="[{ changeColor: isColor[1] }, span1]"
                                    @click="change(1), changeXxhd(2)"
                                    >未开始</span
                                >
                                <span
                                    :class="[{ changeColor: isColor[2] }, span1]"
                                    @click="change(2), changeXxhd(3)"
                                    >已结束</span
                                >
                            </div>
                            <div id="threeBottom">
                                <!--线下活动-->
                                <div
                                    class="box"
                                    v-for="(val, index) in arrTwo"
                                    :key="index"
                                    v-show="index < 6"
                                    @click="goHdxq(val.id)"
                                >
                                    <div class="div1" v-show="val">
                                        <div class="img1">
                                            <img
                                                :src="val.cover"
                                                :alt="val.offlineCourseTitle"
                                                v-if="val != 0"
                                            />
                                        </div>
                                        <p class="p1">{{ val.offlineCourseTitle }}</p>
                                    </div>
                                    <p class="p2" v-if="val != 0">
                                        活动开始时间：{{
                                            val.startTime &&
                                                val.startTime.split(" - ")[0]
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div id="threeRight">
                            <div id="threeRightHead">
                                <p id="p3">
                                    积分排行榜
                                    <a
                                        href="javascript:void(0);"
                                        class="a1"
                                        @click="jump(4)"
                                        >更多&gt;&gt;</a
                                    >
                                </p>
                                <!--公用线-->
                                <div class="publicLine white">
                                    <div class="publicChild"></div>
                                </div>
                                <div class="div3">
                                    <span class="spanOne">排名</span>
                                    <span class="spanTwo">姓名</span>
                                    <span class="spanThree">学分</span>
                                </div>
                                <div
                                    class="divBox"
                                    v-for="(val, index) in arrNine"
                                    :key="index"
                                >
                                    <span class="spanOne">
                                        <img
                                            v-if="
                                                (index == 0) |
                                                    (index == 1) |
                                                    (index == 2)
                                            "
                                            :src="
                                                index === 0
                                                    ? 'static/img/3.png'
                                                    : index == 1
                                                    ? 'static/img/2.png'
                                                    : index == 2
                                                    ? 'static/img/5.png'
                                                    : ''
                                            "
                                        />
                                        <span
                                            v-if="
                                                index != 0 && index != 1 && index != 2
                                            "
                                            >{{ index + 1 }}</span
                                        >
                                    </span>
                                    <span class="spanTwo">{{ val.NICKNAME }}</span>
                                    <span class="spanThree">{{ val.CREDIT }}</span>
                                </div>
                            </div>
                            <div id="threeRightBottom"></div>
                        </div>
                    </div>
                    <!--轮播图-->
                    
                    <div id="secBanner">
                            <eazyswiper :type="1" :location="2"></eazyswiper>
                    </div>
          
                    <!--在线课程-->
                    <div class="four" v-if="arrThree.length">
                        <div class="PublicHead">
                            <span class="headLeft">在线课程</span>
                            <a href="javascript:void(0);" class="as" @click="jump(5)"
                                >更多&gt;&gt;</a
                            >
                        </div>
                        <!--公用线-->
                        <div class="publicLine">
                            <div class="publicChild"></div>
                        </div>
                        <div class="div2">
                            分类：
                            <span
                                :class="[{ changeColor: chooseColor[index] }, span3]"
                                v-for="(val, index) in arrThree"
                                :key="index"
                                @click="changeZxkc(val.id), classifyColor(index)"
                                >{{ val.coursesType }}</span
                            >
                        </div>
                        <div class="fourContent">
                            <div
                                class="box1"
                                v-for="(val, index) in arrFour"
                                :key="index"
                                @click="goClassDetails(val)"
                                v-show="val"
                            >
                                <div class="fourImg">
                                    <img
                                        :src="val.cover"
                                        :alt="val.totalTitle"
                                        v-if="val != 0"
                                    />
                                </div>
                                <p class="fourP">
                                    <span class="mes">{{ val.totalTitle }}</span><br />
                                    <img src="../../../static/img/play.png" class="play">
                                    <span class="fourSpan">{{ val.popularity }}人</span>
                                
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--热门推荐-->
                    <div class="four" v-if="arrSix.length">
                        <div class="PublicHead">
                            <span class="headLeft">热门推荐</span>
                            <a href="javascript:void(0);" class="as" @click="jump(6)"
                                >更多&gt;&gt;</a
                            >
                        </div>
                        <!--公用线-->
                        <div class="publicLine">
                            <div class="publicChild"></div>
                        </div>
                        <div class="div2"></div>
                        <div class="fourContent">
                            <div
                                class="box1"
                                v-for="(val, index) in arrSix"
                                :key="index"
                                @click="goClassDetails(val)"
                                v-show="val"
                            >
                                <div class="fourImg">
                                    <img :src="val.cover" :alt="val.totalTitle" />
                                </div>
                                <p class="fourP">
                                    <span class="mes">{{ val.totalTitle }}</span><br/>
                                    <img src="../../../static/img/play.png" class="play">
                                    <span class="fourSpan">{{ val.popularity }}人</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--风采展示-->
                    <div class="four" v-if="arrSeven.length">
                        <div class="PublicHead">
                            <span class="headLeft">风采展示</span>
                            <a href="javascript:void(0);" class="as" @click="jump(7)"
                                >更多&gt;&gt;</a
                            >
                        </div>
                        <!--公用线-->
                        <div class="publicLine">
                            <div class="publicChild"></div>
                        </div>
                        <div class="div2"></div>
                        <div class="fourContent">
                            <div
                                class="box1"
                                v-for="(val, index) in arrSeven"
                                :key="index"
                                @click="goFczsDetails(val)"
                                v-show="val"
                            >
                                <div class="fourImg">
                                    <img :src="val.image" :alt="val.title" />
                                </div>
                                <p class="fourP">
                                    <span class="mes">{{ val.title }}</span>
                                    <img src="../../../static/img/play.png" class="play">
                                    <span class="fourSpan">{{ val.popularity }}人</span>
        
                                </p>
                            </div>
                        </div>
                    </div>
        
                    <!--檀城文化-->
                    <div class="five">
                        <div class="PublicHead">
                            <span class="headLeft">密云文化</span>
                            <a href="javascript:void(0);" class="as" @click="jump(8)"
                                >更多&gt;&gt;</a
                            >
                        </div>
                        <!--公用线-->
                        <div class="publicLine">
                            <div class="publicChild"></div>
                        </div>
                        <div>
                            <div id="fiveLeft">
                                <img :src="img" :alt="title" />
                            </div>
                            <div id="fiveRight">
                                <p
                                    class="fiveP"
                                    v-for="(val, index) in arrEight"
                                    :key="index"
                                >
                                    <!-- <div class="ball"></div> -->
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:#BFBFBF;margin-bottom:10px;margin-right:10px;"></span>
                                    <span
                                        class="tcwhSpan"
                                        @click="gotcwhDetails(val.id)"
                                        >{{ val.title }}</span
                                    ><span class="fiveSpan">{{
                                        val.creaTime.time &&
                                            val.creaTime.time | dateFormat
                                    }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--期刊-->
                    <div class="six" v-if="arrFive.length">
                        <div class="PublicHead">
                            <span class="headLeft">期刊</span>
                            <a href="javascript:void(0);" class="as" @click="jump(9)"
                                >更多&gt;&gt;</a
                            >
                        </div>
                        <!--公用线-->
                        <div class="publicLine">
                            <div class="publicChild"></div>
                        </div>
                        <div id="sixContent">
                            <div
                                class="sixImg"
                                v-for="(val, index) in arrFive"
                                @click="goQkDetails(val)"
                                :key="index"
                            >
                                <img
                                    :src="val.coverImg"
                                    v-if="val != 0"
                                    alt="加载失败"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom"></div>
                <!-- 公告详情 -->
                <div v-if="showMessageTag" class="message-client-box">
                    <div class="message-content-box">
                        <div
                            @click="showMessageTag = false"
                            class="message-close flex-row iconfont"
                        >
                            &#xe66f;
                        </div>
                        <div class="message-detail-box">
                            <div class="message-title">
                                {{ showMessageData.title }}
                            </div>
                            <div class="message-time">
                                {{ showMessageData.createTime.time | dateFormat }}
                            </div>
                            <div class="message-content">
                                {{ showMessageData.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
</template>

<script>
export default {
    name: "shouye",
    data() {
        return {
            span1: "span1",
            isColor: [0, 0, 0, 1], //切换class
            span3: "span3",
            chooseColor: [],
            arrOne: [], //综合资讯
            arrTwo: [], //线下活动
            arrThree: [], //在线课程类型
            arrFour: [], //在线课程
            arrFive: [], //期刊
            arrSix: [], //热门推荐
            arrSeven: [], //风采展示
            arrEight: [], //檀城文化
            arrNine: [], //积分商城
            arrTen: [], //公告通知
            showMessageTag: false,
            showMessageData: {},
            img: "",
            title: "",
            refer:'',
        };
    },
    methods: {
        showMessage(val) {
            this.showMessageData = val;
            this.showMessageTag = true;
        },
        //线下活动详情
        goHdxq(x) {
            this.$router.push({
                name: "hdxq",
                query: {
                    id: x
                }
            });
        },
        //资讯详情
        goDetails(i) {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: i,
                    t1: "首页",
                    t2: "综合资讯"
                }
            });
        },
        //在线课程详情
        goClassDetails(val) {
            this.$router.push({
                name: "classDetails",
                query: {
                    id: val.id,
                    title: val.totalTitle,
                    t1: "首页",
                    t2: "在线课程"
                }
            });
        },
        //风采展示详情
        goFczsDetails(val) {
            this.$router.push({
                name: "fczsdetail",
                query: { id: val.id, t1: "首页", t2: "风采展示" }
            });
        },
        //檀城文化详情
        gotcwhDetails(i) {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: i,
                    t1: "首页",
                    t2: "密云文化"
                }
            });
        },
        //资讯类
        getList(id) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: id,
                    isHome: 1
                },
                success: res => {
                    if (res.code == 200) {
                        switch (id) {
                            case 11:
                                this.arrOne = res.message.records;
                                this.refer = this.arrOne[0].image
                                if (this.arrOne.length > 7) {
                                    this.arrOne = res.message.records.splice(
                                        0,
                                        7
                                    );
                                }
                                break;
                            case 9000:
                                this.arrSeven = res.message.records;
                                if (this.arrSeven.length > 10) {
                                    this.arrSeven = res.message.records.splice(
                                        0,
                                        10
                                    );
                                }

                                break;
                            case 10000:
                                this.arrEight = res.message.records;
                                if (this.arrEight.length > 5) {
                                    this.arrEight = res.message.records.splice(
                                        0,
                                        5
                                    );
                                }
                                this.img = this.arrEight[0].image;
                                this.title = this.arrEight[0].title;
                                // console.log(this.arrEight);
                                break;
                            default:
                                break;
                        }
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        },
        //线下活动class样式
        change(x) {
            let arrA = [0, 0, 0, 0];
            arrA[x] = 1;
            this.isColor = arrA;
        },
        jump(k) {
            switch (k) {
                case 1:
                    this.$router.push({
                        name: "articalList",
                        query: {
                            id: 11,
                            t1: "首页",
                            t2: "综合资讯"
                        }
                    });
                    break;
                case 2:
                    if (this.$store.state.hasLogin) {
                        this.$router.push({
                            name: "grzx",
                            query: { type: "7" }
                        });
                    } else {
                        this.$router.push({ name: "login" });
                    }
                    break;
                case 3:
                    this.$router.push({
                        name: "xxhd"
                    });
                    break;
                case 4:
                    if (this.$store.state.hasLogin) {
                        this.$router.push({
                            name: "grzx",
                            query: { type: "8" }
                        });
                    } else {
                        this.$router.push({ name: "login" });
                    }
                    break;
                case 5:
                    this.$router.push({
                        name: "zxkc"
                    });
                    break;
                case 6:
                    this.$router.push({
                        name: "hot"
                    });
                    break;
                case 7:
                    this.$router.push({
                        name: "fczs"
                    });
                    break;
                case 8:
                    this.$router.push({
                        name: "gjtz"
                    });
                    break;
                default:
                    this.$router.push({
                        name: "qk"
                    });
                    break;
            }
        },
        changeZxkc(x) {
            //在线课程
            this.$ajax({
                method: "post",
                url: "homePage/getCoursesSeries",
                data: {
                    courseTypeOne: x
                },
                success: res => {
                    if (res.code == 200) {
                        this.arrFour = res.message.records;

                        if (this.arrFour.length < 5) {
                            for (var i = this.arrFour.length; i < 5; i++) {
                                this.arrFour[i] = 0;
                            }
                        } else if (
                            this.arrFour.length > 5 &&
                            this.arrFour.length < 10
                        ) {
                            for (var i = this.arrFour.length; i < 6; i++) {
                                this.arrFour[i] = 0;
                            }
                        } else if (this.arrFour.length > 10) {
                            this.arrFour = res.message.records.splice(0, 10);
                        }
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        },
        //期刊详情
        goQkDetails(val) {
            this.$router.push({
                name: "qkdetail",
                query: { id: val.id, title: val.title }
            });
        },
        //在线课程样式
        classifyColor(index) {
            for (var i = 0; i < this.chooseColor.length; i++) {
                this.chooseColor[i] = 0;
            }
            this.chooseColor[index] = 1;
        },
        changeXxhd(i) {
            let data = {
                status: i,
                isRTTHP: 1
            };
            //线下活动
            this.$ajax({
                method: "post",
                url: "homePage/getOfflineActivities",
                data: data,
                success: res => {
                    if (res.code == 200) {
                        this.arrTwo = res.message.records;
                        // console.log(this.arrTwo)
                        if (this.arrTwo.length < 3) {
                            for (var i = this.arrTwo.length; i < 3; i++) {
                                this.arrTwo[i] = 0;
                            }
                        } else if (
                            this.arrTwo.length > 3 &&
                            this.arrTwo.length < 6
                        ) {
                            for (var i = this.arrTwo.length; i < 6; i++) {
                                this.arrTwo[i] = 0;
                            }
                        } else if (this.arrTwo.length > 6) {
                            this.arrTwo = res.message.records.splice(0, 6);
                        }
                    }
                },
                error: res => {
                    console.log(res);
                }
            });
        },
        
    },
    created() {
        //综合资讯
        this.getList(11);
        //线下活动
        this.changeXxhd(0);
        //在线课程 类型
        this.$ajax({
            method: "post",
            url: "homePage/getCoursesType",
            data: {
                isRecommend: 1
            },
            success: res => {
                if (res.code == 200) {
                    this.arrThree = res.message;
                    this.arrThree.unshift({
                        coursesType: "全部"
                    });
                    for (var i = 0; i < this.arrThree.length; i++) {
                        if (i == 0) {
                            this.chooseColor[i] = 1;
                        } else {
                            this.chooseColor[i] = 0;
                        }
                    }
                }
            },
            error: res => {
                console.log(res);
            }
        });
        this.changeZxkc();
        //期刊
        this.$ajax({
            method: "post",
            url: "homePage/getPeriodical",
            data: {
                isHome: 1
            },
            success: res => {
                if (res.code == 200) {
                    this.arrFive = res.message.records;
                    if (this.arrFive.length < 7) {
                        for (var i = this.arrFive.length; i < 7; i++) {
                            this.arrFive[i] = 0;
                        }
                    } else if (this.arrFive.length > 7) {
                        this.arrFive = res.message.records.splice(0, 7);
                    }
                }
            },
            error: res => {
                console.log(res);
            }
        });

        // 热门推荐
        this.$ajax({
            method: "post",
            url: "homePage/getCoursesSeries",
            data: {
                isHot: 1
            },
            success: res => {
                if (res.code == 200) {
                    this.arrSix = res.message.records;
                    this.arrSix.length > 10 ? (this.arrSix.length = 10) : "";
                }
            },
            error: res => {
                console.log(res);
            }
        });

        //风采展示
        this.getList(9000);
        //檀城文化
        this.getList(10000);
        //积分排行
        this.$ajax({
            url: "userApi/noCreditList",
            method: "post",
            success: res => {
                if (res.code == 200) {
                    this.arrNine = res.list.records;
                    if (this.arrNine.length > 10) {
                        this.arrNine.length = 10;
                    }
                }
            },
            error: () => {}
        });
        //公告通知 跳转个人中心type=7 跳转登录页面
        this.$ajax({
            method: "post",
            url: "userApi/notice",
            success: res => {
                if (res.code == 200) {
                    this.arrTen = res.message.records;
                    if (this.arrTen.length > 7) {
                        this.arrTen.length = 7;
                    }
                    // console.log(this.arrTen);
                }
            },
            error: () => {}
        });
    }
};
</script>


<style scoped lang="scss">
* {
    margin: 0;
    padding: 0;
}

html,
body {
    width: 100%;
    height: 100%;
}

.onePs {
    cursor: pointer;
}

.spanTitle {
    display: inline-block;
    width: 220px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.headLeft {
    font-size: 18px;
    font-weight: 600;
}

.as {
    text-decoration: none;
    font-size: 14px;
    color: #6ac0e8;
    float: right;
    margin-top: 10px;
}

#wrapS {
    background-color: #f2f2f2;
    overflow: hidden;
    margin: 0 auto;
    min-height: 500px;
}

#center {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
}

#top_first {
    background-color: #fff;
    padding: 40px 0;
}

#three {
    padding: 30px 0;
}

#three,
.four,
.five,
.six {
    width: 1000px !important;
    margin: 0 auto !important;
}

#one{
    width: 62%;
    padding-right:35px;
    border-right: 1px solid #ccc;
    /* border: 1px solid gainsboro; */
}
#two {
    width: 35%;
    margin-left:30px;
}
#oneHead,
#twoHead {
    overflow: hidden;
}

#one {
    float: left;
}

#two {
    float: right;
}

.spans {
    float: right;
    color: gray;
}

.headLeft {
    padding: 5px 0;
    display: inline-block;
}

#three {
    width: 100%;
    margin: 20px 0;
    overflow: hidden;
}

#threeLeft {
    float: left;
    width: 62%;
}

#threeRight {
    float: right;
    width: 33%;
    margin-top: 5px;
}

#threeLeftHead {
    width: 630px;
}

.span1 {
    margin: 0 5px;
    color: black;
    cursor: pointer;
}

.changeColor {
    margin: 0 5px;
    color: #6ac0e8;
    cursor: pointer;
}

#threeBottom {
    width: 100%;
    margin: 5px 0;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.box {
    display: inline-block;
    width: 192px;
    margin-top: 10px;
    cursor: pointer;
}

.img1 {
    width: 100%;
    height: 130px;
    border: 1px solid #ddd;
    box-sizing: border-box;
}

.img1 img {
    width: 100%;
    min-height: 100%;
    height: 64px;
}

.p1 {
    background-color: black;
    color: white;
    opacity: 0.5;
    filter: alpha(Opacity=50);
}

.p2 {
    font-size: 14px;
    padding: 5px;
}

#p3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 18px;
    height: 18px;
    padding: 5px 0;
    margin-bottom: 5px;
}

.div1 {
    margin: 5px 0;
}

.div3 {
    padding-top: 15px;
    padding-bottom: 8px;
}

.div2 {
    padding: 10px 0;
}

// #threeRightHead {
//     padding: 5px;
// }
.four,
.five,
.six {
    width: 100%;
}

.six {
    padding-bottom: 40px;
}

#wrapBottom {
    background-color: #f2f2f2;
}

.fourContent {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.PublicHead {
    width: 998px;
}

.span3 {
    margin: 0 5px;
    cursor: pointer;
}

.box1 {
    width: 192px;
    display: inline-block;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
}

.box1:nth-child(5n) {
    margin-right: 0;
}

.fourImg {
    width: 100%;
    height: 130px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    overflow: hidden;
}

.play {
    float: left;
    margin-top: 10px;
    margin-right: 10px;
}

.fourImg img {
    width: 100%;
    min-height: 100%;
}

.fourP {
    padding: 5px;
    height: 16px;
    line-height: 16px;
}

.fourSpan {
    font-size: 13px;
    float: left;
    color: gray;
    margin-top: 10px;
}

.swiper-container {
    width: 100%;
    height: 300px;
    text-align: center;
}

.swiper-slide {
    width: 1000px;
    height: 100%;
}

.swiper-slide img {
    width: 100%;
    height: 100%;
}

.oneDivs,
.twoDivs {
    padding: 10px 0;
    height: 16px;
    line-height: 16px;
    font-size: 14px;
}

.five {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 30px 0;
}

.fiveP {
    margin: 6px 2px;
}

.fiveSpan {
    float: right;
    height: 21px;
    line-height: 21px;
}

#fiveLeft {
    float: left;
    width: 250px;
    height: 170px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    margin: 30px 0;
}
.ball {
    float:left;
    margin-right:10px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color:#BFBFBF;
    margin-top: 5px;
}
#fiveLeft img {
    width: 100%;
    height: 100%;
}

#fiveRight {
    float: right;
    width: 730px;
    height: 170px;
    /* border: 1px solid black; */
    padding-left: 20px;
    margin: 25px 0;
}

#sixContent {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.sixImg {
    position: relative;
    display: inline-block;
    width: 82px;
    height: 105px;
    margin-top: 15px;
    cursor: pointer; // border: 1px solid #ddd;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
}

.sixImg img {
    position: absolute;
    top: 50%;
    margin-top: -52.5px;
    left: 50%;
    margin-left: -68.5px;
    width: auto;
    height: 100%;
    vertical-align: middle;
}

.p1ShouYe {
    font-size: 14px;
    color: grey;
}

#img1Sy {
    width: 1000px;
}

.div1 {
    overflow: hidden;
}

.spanOne {
    margin-right: 60px;
    display: inline-block;
    width: 40px;
    text-align: center;
    margin-left: 5px;
}

.spanTwo {
    width: 100px;
    display: inline-block;
    margin-right: 15px;
}

.spanThree {
    display: inline-block;
    width: 50px;
    margin-left: 10px;
}

.a1 {
    color: #6ac0e8;
    font-size: 14px;
    float: right;
}

.swiper-p {
    position: absolute;
    left: 0;
    bottom: 0;
}

.paginationName {
    text-align: right;
    bottom: 5px;
}

#banner {
    width: 1000px !important;
    position: relative;
}

.messageP {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 1000px;
    height: 30px;
    line-height: 30px;
    background-color: black;
    padding-left: 5px;
    opacity: 0.7;
    color: white;
    text-align: left;
}

.publicLine {
    width: 100%;
    border-bottom: 4px solid gainsboro;
    position: relative;
}

.white {
    border-bottom: 4px solid #fff;
}

.publicChild {
    width: 70px;
    border-bottom: 4px solid #6ac0e8;
    position: absolute;
    top: 0;
    left: 0;
}

.fenyeqi {
    text-align: right;
}

.mes {
    display: inline-block;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#threeCenter {
    margin: 10px 0 5px 0;
}

.divBox {
    height: 36px;
    line-height: 36px;
    margin-top: 5px;
}

.tcwhSpan {
    width: 600px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
}

.message-client-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 999;
    .message-content-box {
        padding: 60px 20px;
        width: 500px;
        position: absolute;
        top: 200px;
        left: 50%;
        word-break: break-all;
        margin-left: -260px;
        z-index: 10;
        border-radius: 4px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        background-color: #fff;
        padding-top: 35px;
        .message-close {
            font-size: 25px;
            width: 25px;
            height: 25px;
            line-height: 25px;
            position: absolute;
            top: 0;
            right: 0;
            margin: 5px;
            color: #999;
            cursor: pointer;
            transition: all ease 0.3s;
        }
        .message-close:hover {
            color: #000;
        }
        .message-detail-box {
            height: 156px;
            max-height: 450px;
            overflow-y: scroll;
            .message-title {
                font-size: 18px;
                font-weight: bold;
            }
            .message-time {
                font-size: 14px;
                padding: 5px 0;
                color: #999;
            }
            .message-content {
                font-size: 16px;
            }
        }
    }
}

// .home >>> .title {
//   color: rebeccapurple;
// }
.banner {
    width: 100% !important;
    height: 420px !important;
    img {
        height: 420px !important;
    }
}

.swiper-container {
    height: 420px !important;
}

#secBanner {
    width: 1000px !important;
    margin: 0 auto !important;
}

#secBanner .banner {
    width: 1000px !important;
    height: 420px !important;
    img {
        height: 420px !important;
    }
}

.four {
    padding: 30px 0;
}

#oneContent_left {
    width: 45%;
}

#oneContent {
    width: 55%;
}
</style>



// WEBPACK FOOTER //
// src/components/shouye/shouye.vue